import { Button } from "@/components/Button"
import { Image } from "@/components/common/Image"
import { Edit, Wallet } from "@/Images"
import { IBAN, useIBANStore } from "@usher/pe-client-front-end-lib"
import { Fragment, useEffect, useState } from "react"
import "./style.sass"
import { TitleEditModal } from "./TitleEditModal"

const SIGNS = {
  EUR: "€",
  USD: "$",
}
export const HeaderInfobar = () => {
  const [ibanId, setIbanId] = useState<IBAN | null>(null)
  const { iban_list } = useIBANStore()
  const [currentIban, setCurrentIban] = useState<IBAN | null>(null)
  useEffect(() => {
    setCurrentIban(iban_list.find((iban) => iban.id === currentIban?.id) ?? iban_list[0])
  }, [iban_list])
  const nextIban = () => {
    const ibanLength = iban_list.length
    const currentIndex = iban_list.findIndex((iban) => iban.id === currentIban?.id)
    if (currentIndex === -1 || ibanLength === 0) return
    const nextIndex = (currentIndex + 1) % ibanLength
    setCurrentIban(iban_list[nextIndex])
  }
  const currencySign = SIGNS[(currentIban?.currency as keyof typeof SIGNS) ?? "EUR"]
  return (
    <Fragment>
      <TitleEditModal show={ibanId} onClose={() => setIbanId(null)} />
      <div className="infobar border">
        <div className="infobar__row">
          <div className="infobar__my-current">
            <div className="wallet_image">
              <Wallet />
            </div>
            <div className="flex items-center justify-between w-full">
              <div className="account-number">
                <div>
                  <span>{currentIban?.title ?? "My Current"}</span>
                  <span className="fiat">{currentIban?.currency}</span>
                  <div className="action" onClick={() => setIbanId(currentIban)}>
                    <Edit />
                  </div>
                </div>
                <div>
                  <span>№ {currentIban?.account_number}</span>
                  {/* <div className="action" onClick={() => IBANApi.downloadRequisites(currentIban)}>
                  <DownloadIcon />
                </div> */}
                </div>
              </div>
              <div className="w-8 h-8 rounded-full bg-main-main/10 hover:bg-main-main cursor-pointer grid place-items-center" onClick={nextIban}>
                <Image src="drop.svg" className="-rotate-90 w-3 ml-[2px]" />
              </div>
            </div>
          </div>
          <div className="infobar__total-available">
            <h1>
              {Number(currentIban?.balance ?? 0).toFixed(2)} <span>{currentIban?.currency}</span>
            </h1>
            <p>Total available</p>
          </div>
        </div>
        <div className="infobar__row">
          <div className="infobar__actions flex-col lg:flex-row shrink-0">
            <Button to="/iban/new-payment" className="flex-1 max-h-[44px]">
              + New Payment
            </Button>
            <Button variant="outlined" color="inherit" to={`/iban/requisites/${currentIban?.account_number ?? ""}`} className="flex-1 max-h-[44px]">
              Requisites
            </Button>
          </div>
          <div className="infobar__balances flex-col xl:flex-row">
            <div>
              <p>Current balance</p>
              <span>
                {Number(currentIban?.balance ?? 0).toFixed(2)}
                {currencySign}
              </span>
            </div>
            <div>
              <p>Reserved</p>
              <span>0.00{currencySign}</span>
            </div>
            <div>
              <p>Available Balance</p>
              <span>
                {Number(currentIban?.balance ?? 0).toFixed(2)}
                {currencySign}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
